<template>
  <v-app :style="appBarHeightStyle">
    <a class="skip-link" href="#main-content">メインコンテンツへ移動</a>
    <AppHeader :app-bar-height="appBarHeight" />
    <v-main ref="mainContent" id="main-content" tabindex="-1">
      <router-view />
    </v-main>
    <BackToTop />
    <AppFooter />
  </v-app>
</template>

<script>
import AppFooter from "./components/AppFooter";
import AppHeader from "./components/AppHeader";
import BackToTop from "./components/BackToTop";

const MOBILE_APP_BAR_HEIGHT = 56;
const TABLET_APP_BAR_HEIGHT = 56;
const DESKTOP_APP_BAR_HEIGHT = 56;

export default {
  name: "App",
  components: {
    AppFooter,
    AppHeader,
    BackToTop,
  },
  computed: {
    appBarHeight() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return DESKTOP_APP_BAR_HEIGHT;
      }

      if (this.$vuetify.breakpoint.smAndUp) {
        return TABLET_APP_BAR_HEIGHT;
      }

      return MOBILE_APP_BAR_HEIGHT;
    },
    appBarHeightStyle() {
      return {
        "--site-app-bar-height": `${this.appBarHeight}px`,
      };
    },
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        const mainContent = this.$refs.mainContent;
        const element = mainContent && mainContent.$el;
        if (!element) {
          return;
        }

        try {
          element.focus({ preventScroll: true });
        } catch (error) {
          element.focus();
        }
      });
    },
  },
};
</script>

<style lang="scss">
@use "./assets/sass/variables" as v;
.v-application {
  font-family: v.$noto-serif-font !important;
  font-weight: 400;
  .title {
    font-family: v.$noto-serif-font !important;
    font-weight: 400;
  }
}
.v-toolbar__content {
  border-bottom: v.$sub-color solid 1px !important;
}
.skip-link {
  position: fixed;
  top: 0.8rem;
  left: 0.8rem;
  z-index: 1000;
  padding: 0.8rem 1.2rem;
  color: white;
  background-color: #211c1a;
  transform: translateY(-150%);
  transition: transform 0.15s ease-out;
}
.skip-link:focus {
  outline: 3px solid white;
  outline-offset: 2px;
  transform: translateY(0);
}
#main-content:focus {
  outline: none;
  box-shadow: none;
}

// Async route components must reserve a viewport of content before they
// resolve so the footer never flashes into view and shifts down the page.
#main-content > .v-main__wrap {
  min-height: calc(100vh - var(--site-app-bar-height, 56px));
  min-height: calc(100svh - var(--site-app-bar-height, 56px));
}

@media (prefers-reduced-motion: reduce) {
  .skip-link {
    transition: none;
  }
}
</style>
